import { useContext } from "react";
import { ModalContext } from "@/providers/ModalProvider";
import type { ModalContextProps } from "@/types/providers/modal";

export function useModal() {
  const context = useContext(ModalContext) as ModalContextProps;
  if (!context) throw new Error("useModal must be used within a ModalProvider");
  return context;
}
